<template>
  <b-modal 
      class="modal-detail"
      :dialog-class="'modal-detail ' + (!isExpanded ? '' : 'b-dialog-large')"
      scrollable 
      :no-close-on-backdrop=true 
      :title="label" 
      :no-close-on-esc=true 
      v-model="show" 
      @cancel="copyDataAction" 
      ok-title="Close" 
      ok-variant="success" 
      @hidden="$emit('close')">
      <template #modal-header>
        <div class="w-100">
          <b-row>
            <b-col cols="9" class="d-flex pl-sm-0 pl-md-3">
              <span class="mr-1 d-sm-flex d-md-none">
                  <b-button size="sm" class="ml-1 btn-back " @click="$emit('close')"><b-icon-arrow-left /></b-button>
              </span>
              <h5 class="modal-title"><app-long-text :maxLength="15" :mdMaxLength="50" :text="label" /></h5>
            </b-col>
            <b-col cols="3">
              <span class="float-right mr-1 d-md-block d-sm-none">
                  <b-button size="sm" v-if="!isExpanded" class="expand btn-link border-0 mt-1" @click="isExpanded = true">
                    <b-icon-arrows-angle-expand />
                  </b-button>
                  <b-button size="sm" v-else class="expand btn-link border-0 mt-1" @click="isExpanded = false">
                    <b-icon-arrows-angle-contract />
                  </b-button>
                  <b-button size="sm" class="mt-1 ml-1 btn-link btn-popup-close" @click="$emit('close')"><b-icon-x /></b-button>
              </span>
            </b-col>
          </b-row>
        </div>
      </template>
    <div>
      <slot/>
    </div>
    <template #modal-footer="{ ok, cancel }">
      <slot name="modal-left-button"></slot>
       <b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
			<b-button v-if="showCopyData" size="sm" :variant="cancelVariant" class="float-right btn-outline-success" @click="cancel()">
				{{ cancelTitle }}
			</b-button>
       </b-overlay>
      <b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				{{ okTitle }}
			</b-button>
		</template>
  </b-modal>
</template>

<script>
export default {
  name: 'PopupWrap',
  //props: ["copyDataMethod", "isShowCopyData", "label"],
  props: {
    copyDataMethod: {},
    isShowCopyData: {
      default: true,
      type: Boolean,
    },
    label: {
      required: true,
      type: String,
    },
    okTitle: {
      default: 'Close',
      type: String,
    },
    cancelTitle: {
      default: 'Copy Data',
      type: String,
    },
    okVariant: {
      default: 'success',
      type: String,
    },
    cancelVariant: {
      default: 'secondary',
      type: String,
    },
     isBusy: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      show : true,
      isExpanded: false,
    }
  },
  mounted() {
    const close = (e) => {
      const ESC = 27;
      if (e.keyCode !== ESC) return;
      this.$emit('close');
    };

    /*document.addEventListener('keyup', close);
    this.$on('hook:destroyed', () => {
      document.removeEventListener('keyup', close);
    });*/

    this.activate();
    this.$on('hook:destroyed', () => {
      this.deactivate();
    });
  },
  computed : {
    showCopyData() {
      if (this.isShowCopyData != null && this.isShowCopyData != undefined) return this.isShowCopyData;
      return true;
    }
  },
  methods: {
    copyDataAction(modalEvent) {
      this.$emit("copyDataMethod", modalEvent)
    },
    activate() {
      this.previousActiveElement = document.activeElement;
      this.inert();
    },
    async deactivate() {
      await this.inert(false);
    },
    async inert(status = true) {
      await this.$nextTick();
      [...this.$root.$el.children].forEach((child) => {
        if (child === this.$el || child.contains(this.$el)) return;
        child.inert = status;
      });
    },
  },
};
</script>

<style>
.modal-dialog {
    max-width: 1008px !important;
    height: 100vh;
    display: flex;
}
.modal-body {
  background: #EEF0F8 !important;
}

.b-dialog-large {
  max-width: 99% !important;
  max-height: 100% !important;
}
</style>